<template>
  <div class="section desc-1 mt-3" id="platform-sect">
    <div class="container">
      <div class="first-section-solution-page row align-items-center">
        <div class="col-lg-6 col-12">
          <div class="row">
            <div class="col-12">
              <h3 class="title">The <span class="font-bold">Platform</span></h3>
            </div>
            <div class="col-12">
              <span class="sub-text text-center mb-5"
                ><b>The Ear Platform</b> it's an end to end
                <b>turnkey solution</b> with the BO that
                <b>combines The Ear aggregator tools</b> into a back office that
                is clean, has a simple UI and mobile friendly interface.
                Built-in CMS for easy to manage front end content and the entire
                website infrastructure, comprehensive agent system ensuring a
                single platform that can manage both online and offline
                operations.<br />Built with microservices technology,
                omnichannel solutions, multi-brand management, and comprehensive
                tools <b>for all the Operator's departments</b>, making
                day-to-day activities as seamless as possible, because we
                believe in giving our clients full autonomy to grow their
                business as they see fit.</span
              ><br />
              <span class="sub-text text-center mb-5"
                >Our platform is in compliance with multiple Jurisdictions such
                as Romania, Italy, MGA.<br />Suitable clients:<br /><span
                  ><strong>B2C Operators</strong><br />(online casino/sportsbook
                  operators)</span
                ><br />
                <span
                  ><strong>B2B Providers</strong><br />(turnkey Solutions, White
                  Label providers) that require a ready to go out of box
                  <b>brandable</b> technology.</span
                >
              </span>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-12 pl-lg-5 p-0">
          <img
            class="img-fluid"
            :src="this.publicPath + 'assets/img/pngs/the-platform.png'"
            alt="the ear igaming platform"
            title="The Ear igaming platform"
          />
        </div>
      </div>
      <div class="row multiple-items mt-5">
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="100">
          <div class="bro-card-orange">
            <p>Agent System</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="200">
          <div class="bro-card-orange">
            <p>CMS - Page and banners management</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="300">
          <div class="bro-card-orange">
            <p>GGR - Statement Reports</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="400">
          <div class="bro-card-orange">
            <p>Real-time player balance exposure</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="500">
          <div class="bro-card-orange">
            <p>Campaign profitability</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="600">
          <div class="bro-card-orange">
            <p>Risk &amp; security tabs</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="700">
          <div class="bro-card-orange">
            <p>Detailed player management</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="800">
          <div class="bro-card-orange">
            <p>OMS System</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="900">
          <div class="bro-card-orange">
            <p>Real-time cashier</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="1000">
          <div class="bro-card-orange">
            <p>Mobile friendly</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="1100">
          <div class="bro-card-orange">
            <p>Multi level permission feature</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="1200">
          <div class="bro-card-orange">
            <p>Invoicing functionality</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="1300">
          <div class="bro-card-orange">
            <p>and many more!</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurSolutions_Page",
  components: {},

  data() {
    return {
      lang: localStorage.getItem("language") ?? "en",
      loadingComplete: false,
      publicPath: process.env.VUE_APP_PUBLIC_PATH ?? "/",
    };
  },
  computed: {},
  mounted() {},
  created() {
    document.body.style.fontFamily = "Poppins, sans-serif";
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.section {
  padding: 90px 15px 0px 15px;
}

.first-section-solution-page {
  padding-bottom: 45px;
}
.section .title {
  text-align: center;
  font-weight: 700;
  font-size: 25px;
  line-height: 1.44;
  color: #25354d;
  margin: 0px 0px 20px 0px;
}
.section .card {
  text-align: center;
  background: transparent;
  border: 0;
  transition: all 0.4s ease;
}
.section .card .card-img-top {
  transition: all 0.4s ease;
  max-width: 250px;
}
.section .card a {
  color: inherit;
}
.section .card .card-body {
  border: 1px solid transparent;
  margin-top: 1rem;
  transition: all 0.4s ease;
  border-radius: 10px;
}
.section .card .card-body .card-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.section .card:hover .card-body {
  color: #1976d2;
}

.section.desc-1 .title {
  text-align: center;
  color: #ff5722;
}
.section.desc-1 .sub-text {
  text-align: center;
  line-height: 1.75;
  font-size: 17px;
  margin-top: 20px !important;
  font-weight: 500;
}
.section.desc-1 .vacancy-cnt {
  color: #555;
}
.section.desc-1 .vacancy-cnt .title {
  color: #2196f3;
  transition: all 0.4s ease;
}
.section.desc-1 .vacancy-cnt:hover .title {
  color: #ff5722;
}
.section.desc-1 .multiple-items {
  justify-content: left;
}
.section.desc-1 .multiple-items .col-card {
  flex: 0 0 25%;
  margin-bottom: 1.5rem;
}
@media (max-width: 992px) {
  .section.desc-1 .multiple-items .col-card {
    flex: 0 0 33.3%;
  }
}
@media (max-width: 576px) {
  .section.desc-1 .multiple-items .col-card {
    flex: 0 0 50%;
  }
}
.section.desc-1 .multiple-items .col-card .bro-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: #fff;
  color: #666;
  padding: 1rem 1rem;
  border-radius: 15px;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.25);
  transition: all 0.4s ease;
  border: 2px solid transparent;
}
.section.desc-1 .multiple-items .col-card .bro-card .img-fluid {
  max-height: 55px;
}
.section.desc-1 .multiple-items .col-card .bro-card:hover {
  border-color: #1976d2;
  color: #1976d2;
}
.section.desc-1 .multiple-items .col-card .bro-card-orange {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 300px;
  height: 100%;
  background: #e66640;
  color: #fff;
  padding: 8px 20px;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.25);
  transition: all 0.4s ease;
  border: 2px solid transparent;
  border-radius: 999px;
  height: 60px;
}
.section.desc-1 .multiple-items .col-card .bro-card-orange:hover {
  border-color: #ff5722;
  color: #fff;
  background: #ff5722;
}
.section.desc-1 .multiple-items .col-card .bro-card-orange p {
  font-size: 0.8rem;
  text-transform: uppercase;
  margin-bottom: 0px !important;
  font-family: "Montserrat", sans-serif;
  letter-spacing: -0.05em;
  scale: 0.95;
  font-size: 12px;

  @media (max-width: 767px) {
    zoom: 85%;
    line-height: 1.4;
  }
}
.section.desc-1 .providers-grid {
  padding: 1rem 0 0 0;
}
.section.desc-1 .providers-grid > div {
  padding: 0rem 1rem 2.5rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.section.desc-1 .providers-grid > div .provider-img {
  transform: scale(1);
  transition: all 0.4s ease;
  max-height: 50px;
}
.section.desc-1 .providers-grid > div .provider-img:hover {
  transform: scale(1.2);
  cursor: pointer;
}
@media (max-width: 992px) {
  .section.desc-1 .providers-grid > div .provider-img {
    transform: scale(1);
  }
}
@media (max-width: 992px) {
  .section.desc-1 {
    text-align: center;
  }
  .section.desc-1 .title {
    text-align: center;
  }
  .section.desc-1 .sub-text {
    text-align: center;
  }
  .section.desc-1 .btn {
    margin-bottom: 3rem;
  }
  .section.desc-1 .providers-grid > div .provider-img {
    max-height: 50px;
  }
}

.section.breaker-1 {
  padding: 7rem 0px 7rem 0px;
  background: linear-gradient(265deg, #1976d2, #2196f3);
  color: #fff;
  position: relative;
  overflow: hidden;
  margin-bottom: 5rem;
}
.section.breaker-1::before {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: contain;
}
.section.breaker-1 .title {
  text-align: left;
}
/* .section.breaker-1 .sub-text {
  text-align: left;
  margin-bottom: 0rem;
} */
.section.breaker-1 .btn.btn-secondary:hover {
  background-color: #ff5722;
  color: #fff;
}
@media (max-width: 992px) {
  .section.breaker-1 {
    text-align: center;
  }
  .section.breaker-1 .title {
    text-align: center;
  }
  .section.breaker-1 .sub-text {
    text-align: center;
    margin-bottom: 2rem;
  }
  .section.breaker-1 .btn {
    margin-bottom: 5rem;
  }
}
.section.breaker-1.alternate {
  background: linear-gradient(90deg, #fff, #e0e0e0);
  color: #666;
  box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.25);
}
.section.breaker-1.alternate::before {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: contain;
}

.section.breaker-2 {
  display: block;
  padding: 7rem 0;
  margin: 3rem 0 7rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #666;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
}

.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>
